module.exports = __webpack_public_path__ + "static/NotoSansThai-Bold.subset-0b520a188d3c5fcab91c108150d85670.woff";